module.exports = "/_next/static/images/1420958e16c53ce9f92268d14f6fc8d0-pen@tablet768.jpg";